import { render, staticRenderFns } from "./HospitalProfileTabs.vue?vue&type=template&id=34f36fe5"
import script from "./HospitalProfileTabs.vue?vue&type=script&lang=js"
export * from "./HospitalProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./HospitalProfileTabs.vue?vue&type=style&index=0&id=34f36fe5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports